const radii = ['0px', '4px', '8px']

export default radii
